/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snap from 'snapsvg';
// import randomColor from 'randomcolor';

import './LineChart.sass';
// import PropTypes from 'prop-types';

class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };

    this.chart = {
      margin: 50,
      svg: { width: NaN, height: NaN },
      position: { x: 50, y: 50 },
      width: NaN,
      height: NaN,

      $axisGroup: null,
      $backgroundAxisGroup: null,
      $labelGroup: null,
      $pathGroup: null,
    };
  }

  componentDidMount() {
    this.plot();
    this.drawLine(this.state.data);
  }

  redraw(options = {}) {
    const { svg } = this;
    svg.clear();
    this.plot();
    this.drawLine(this.state.data, options);
  }

  clearLines() {
    this.setState({ data: [] }, () => {
      this.redraw();
    });
  }

  plot() {
    const { $svg, svg } = this;
    const {
      xLabel,
      yLabel,
      xLabels,
      yLabels,
      intersection
      // xRange,
      // yRange
    } = this.props;
    // const xRangeDelta = xRange[1] - xRange[0];
    // const yRangeDelta = yRange[1] - yRange[0];

    this.chart.svg.width = $svg.clientWidth;
    this.chart.svg.height = $svg.clientHeight;
    this.chart.width = this.chart.svg.width - (this.chart.margin * 2);
    this.chart.height = this.chart.svg.height - (this.chart.margin * 2);

    /* Draw Axis */
    const axis = {
      x: svg.line(
        this.chart.margin,
        this.chart.height + this.chart.margin,
        this.chart.width + this.chart.margin,
        this.chart.height + this.chart.margin,
      ),
      y: svg.line(
        this.chart.margin,
        this.chart.margin,
        this.chart.margin,
        this.chart.height + this.chart.margin,
      )
    };
    
    const arrow = svg.polygon([0, 10, 6, 10, 3, 0, 0, 10]).attr({ fill: '#aaa' }).transform('r90');
    const arrowReversed = svg.polygon([0, 0, 6, 0, 3, 10, 0, 0]).attr({ fill: '#aaa' }).transform('r90');
    const marker = arrow.marker(0, 0, 10, 10, 0, 5);
    const markerReversed = arrowReversed.marker(0, 0, 10, 10, 0, 5)

    axis.x.attr({ markerEnd: marker });
    axis.y.attr({ markerStart: markerReversed });

    this.chart.$axisGroup = svg.group(axis.x, axis.y);
    this.chart.$axisGroup.addClass('axis-group');

    /* Draw labels */
    const label = { x: [], y: [] };

    const labelDistance = {
      x: (this.chart.width - 30) / 10,
      y: (this.chart.height - 30) / 10,
    };

    for (let i = 1; i <= 10; i += 1) {
      // const value = i / 10;
      // const xValue = value * xRangeDelta;
      // const yValue = value * yRangeDelta;
      label.x.push(svg.text(50 + labelDistance.x * i, 50 + this.chart.height + 20, xLabels[i - 1]));
      label.y.push(svg.text(30, 50 + this.chart.height - (labelDistance.y * i), yLabels[i - 1]));
    }
    const labels = [
      ...label.x,
      ...label.y,
      svg.text(30, 70 + this.chart.height, intersection),
    ];
  
    const xAxisLabel = svg.text(
      this.chart.margin + this.chart.width + 20,
      this.chart.margin + this.chart.height + 30,
      xLabel
    );
    xAxisLabel.addClass('label-legend');
    const yAxisLabel = svg.text(50, 30, yLabel);
    yAxisLabel.addClass('label-legend');

    this.chart.$labelGroup = svg.g(...labels, xAxisLabel, yAxisLabel);
    this.chart.$labelGroup.addClass('label-group');

    /* Draw Background Axis */
    const backgroundAxis = [];
    for (let i = 1; i <= 10; i += 1) {
      const lineX = svg.line(
        0,
        (this.chart.height) - (labelDistance.y * i),
        labelDistance.x * 10,
        (this.chart.height) - (labelDistance.y * i),
      );
      const lineY = svg.line(
        labelDistance.x * i,
        this.chart.height,
        labelDistance.x * i,
        (this.chart.height) - (10 * labelDistance.y)
      );

      backgroundAxis.push(lineX);
      backgroundAxis.push(lineY);
    }

    this.chart.$backgroundAxisGroup = svg.g(...backgroundAxis);
    this.chart.$backgroundAxisGroup.transform(`translate(${[50, 50]})`);
    this.chart.$backgroundAxisGroup.addClass('background-axis-group');

    this.chart.$pathGroup = svg.g();
    this.chart.$pathGroup.addClass('path-group');
    this.chart.$pathGroup.transform('translate(50, 50)');
  }

  drawLine(data, options = {}) {
    const { svg } = this;
    const { skipAnimation = false } = options;
    const { xRange, yRange } = this.props;
    const xRangeDelta = xRange[1] - xRange[0];
    const yRangeDelta = yRange[1] - yRange[0];

    /* Draw data */
    const paths = [];
    const chartWidth = this.chart.width - 30;
    const chartHeight = this.chart.height - 30;
    data.forEach(({ title, value, color }) => {
      const transformedValue = value.map(([x, y]) => [
        (((x - xRange[0]) * chartWidth) / xRangeDelta),
        (((y - yRange[0]) * chartHeight) / yRangeDelta)
      ]);
      const coords = transformedValue.map(([x, y]) => ([
        x,
        this.chart.height - y
      ]));

      let path = coords.map(([x, y]) => `${x} ${y}`).join('L');
      path = 'M' + path;
  
      const visualPath = svg.path(path);
      visualPath.attr({ stroke: color });
      visualPath.data({ title });
      paths.push(visualPath);

      if (!skipAnimation) {
        const pathLength = visualPath.getTotalLength();
        visualPath.attr({ 'stroke-dasharray': pathLength, 'stroke-dashoffset': pathLength });
        // setTimeout(() => {
        visualPath.animate({ 'stroke-dashoffset': 0 }, 1000, window.mina.easeout);
        // }, 1000);
      }
    });

    this.chart.$pathGroup.add(...paths);
  }

  appendLine(newData) {
    const { svg } = this;
    const { xRange, yRange } = this.props;
    const xRangeDelta = xRange[1] - xRange[0];
    const yRangeDelta = yRange[1] - yRange[0];

    /* Draw Data */
    const paths = [];
    const chartWidth = this.chart.width - 30;
    const chartHeight = this.chart.height - 30;
    const { title, value, color } = newData;

    const transformedValue = value.map(([x, y]) => [
      (((x - xRange[0]) * chartWidth) / xRangeDelta),
      (((y - yRange[0]) * chartHeight) / yRangeDelta)
    ]);
    const coords = transformedValue.map(([x, y]) => ([
      x,
      this.chart.height - y
    ]));

    let path = coords.map(([x, y]) => `${x} ${y}`).join('L');
    path = 'M' + path;

    const visualPath = svg.path(path);
    visualPath.attr({ stroke: color });
    visualPath.data({ title });
    paths.push(visualPath);

    const pathLength = visualPath.getTotalLength();
    visualPath.attr({ 'stroke-dasharray': pathLength, 'stroke-dashoffset': pathLength });
    // setTimeout(() => {
    visualPath.animate({ 'stroke-dashoffset': 0 }, 1000, window.mina.easeout);
    // }, 1000);

    this.chart.$pathGroup.add(...paths);
    this.setState({ data: [...this.state.data, newData] });
  }

  render() {
    return (
      <div className="line-chart">
        <svg
          xmlns="http://www.w3.org/1000/svg"
          width="100%"
          height="500"
          ref={(c) => {
            this.$svg = c;
            this.svg = Snap(c);
          }}
        />
      </div>
    );
  }
}

LineChart.propTypes = {
  xLabel: PropTypes.string.isRequired,
  yLabel: PropTypes.string.isRequired,
  xLabels: PropTypes.any.isRequired,
  yLabels: PropTypes.any.isRequired,
  intersection: PropTypes.any.isRequired,
  xRange: PropTypes.arrayOf(PropTypes.number).isRequired,
  yRange: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default LineChart;



// WEBPACK FOOTER //
// ./src/components/LineChart.jsx